import { useMediaQuery, useTheme } from '@material-ui/core'
import { useTouchDevice } from './useTouchDevice'

export function useMobile() {
  const theme = useTheme()
  const isTouchDevice = useTouchDevice()
  return useMediaQuery(theme.breakpoints.down('md')) && isTouchDevice
}
